var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.advertisement !== false)?_c('div',[_vm._v(" まもなくプレビュー画面が開きます。 ")]):_c('div',[_vm._v(" プレビューできません。URLをご確認ください。 ")]),_c('form',{ref:"form"})])}
var staticRenderFns = []

export { render, staticRenderFns }